import { CouponAssigneeEnum } from "@saleor/types/globalTypes";

export const ASSIGNEE_CHOICES = [
  {
    label: "HO Marketing",
    value: CouponAssigneeEnum.HO_MARKETING
  },
  {
    label: "SM Deals",
    value: CouponAssigneeEnum.SM_DEALS
  },
  {
    label: "SMO Commercial",
    value: CouponAssigneeEnum.SMO_COMMERCIAL
  },
  {
    label: "SMO Marketing",
    value: CouponAssigneeEnum.SMO_MARKETING
  },
  {
    label: "Mall Marketing",
    value: CouponAssigneeEnum.MALL_MARKETING
  },
  { label: "App Development", value: CouponAssigneeEnum.APP_DEVELOPMENT }
];

export const COUPON_COLLECTION_TYPE_CHOICES = [
  {
    label: "Community",
    value: "COMMUNITY"
  },
  {
    label: "Campaign",
    value: "CAMPAIGN"
  }
];
